<template>
  <div class="flex flex-wrap items-center gap-3">
    <div
      v-if="modelValue"
      class="flex items-center gap-2 rounded-md border px-3 py-2 font-medium"
    >
      <FontAwesomeIcon :icon="['fal', 'calendar-clock']" />
      <span class="capitalize-first">{{ cSummary }}</span>
    </div>
    <BaseButton
      color="primary"
      icon="calendar-clock"
      :title="modelValue ? $t('button.edit') : $t('button.choose_timeslot')"
      @click="openModal"
    />
  </div>

  <BaseCenteredModal
    v-model:is-modal-open="isModalOpen"
    :title="$t('global.timeslot')"
    size="large"
  >
    <template #body>
      <div class="flex h-[60vh] w-full flex-col">
        <SelectEventTimeslot
          v-bind="$attrs"
          :model-value="modelValue"
          @update:model-value="onSelect"
        />
      </div>
    </template>
  </BaseCenteredModal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment'

import SelectEventTimeslot from '@p/components/Event/SelectEventTimeslot.vue'

/**
 * SelectEventTimeslot in a modal: the form only shows the chosen timeslot
 * and a button; picking a timeslot in the modal closes it. `open` lets the
 * form fetch the timeslots when the modal opens. The modal keeps one height,
 * so the week buttons and the slots do not move under the pointer. Every other
 * attribute (asset, type, eventKind, options, index) goes to the picker.
 */
export default {
  name: 'SelectEventTimeslotModal',
  components: { FontAwesomeIcon, SelectEventTimeslot },
  inheritAttrs: false,
  props: {
    modelValue: { type: Object, required: false, default: null }
  },
  emits: ['update:modelValue', 'open'],
  data() {
    return { isModalOpen: false }
  },
  computed: {
    cSummary() {
      const slot = this.modelValue
      const date = moment(slot.datetime_from ?? slot.date)
        .locale('fr')
        .format('dddd D MMMM YYYY')
      const asset = slot.asset?.name ? ` · ${slot.asset.name}` : ''
      return `${date} · ${slot.string_from} – ${slot.string_to}${asset}`
    }
  },
  methods: {
    openModal() {
      this.isModalOpen = true
      this.$emit('open')
    },
    onSelect(slot) {
      this.$emit('update:modelValue', slot)
      this.isModalOpen = false
    }
  }
}
</script>
